(function () {
  'use strict';

  // Campi su cui cercare. 'body' (descrizione) volutamente escluso:
  // evita i match dentro le schede tecniche.
  var FIELDS = ['title', 'tag', 'product_type', 'vendor', 'variants.sku'];
  var ORIGINAL_PARAM = 'qo';

  function cleanTerm(raw) {
    return raw
      .replace(/[:"()\[\]{}*~^\\\/]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function buildQuery(raw) {
    var words = cleanTerm(raw).split(' ').filter(Boolean);
    if (!words.length) return null;

    return words.map(function (w) {
      // evita che AND/OR/NOT digitati dall'utente diventino operatori
      if (/^(AND|OR|NOT)$/i.test(w)) w = w.toLowerCase();
      return '(' + FIELDS.map(function (f) {
        return f + ':' + w + '*';
      }).join(' OR ') + ')';
    }).join(' AND ');
  }

  // --- Intercetta l'invio dei form di ricerca ---
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;

    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    var raw = input.value.trim();
    if (!raw) return;

    // se l'utente usa gia' la sintassi, non tocchiamo nulla
    if (raw.indexOf(':') !== -1) return;

    var built = buildQuery(raw);
    if (!built) return;

    e.preventDefault();

    // conserva gli altri campi del form (type, options[prefix], ecc.)
    var params = new URLSearchParams();
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.disabled) return;
      if (el.name === 'q' || el.name === ORIGINAL_PARAM) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      params.append(el.name, el.value);
    });

    params.set('q', built);
    params.set(ORIGINAL_PARAM, raw);

    window.location.assign(action.split('?')[0] + '?' + params.toString());
  }, true);

  // --- Pagina risultati: rimetti il termine leggibile ---
  function restore() {
    var params = new URLSearchParams(window.location.search);
    var original = params.get(ORIGINAL_PARAM);
    var rawQuery = params.get('q');
    if (!original) return;

    Array.prototype.forEach.call(
      document.querySelectorAll('input[name="q"]'),
      function (i) { i.value = original; }
    );

    // frasi che contengono la query dentro una traduzione
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-search-clean]'),
      function (el) {
        if (rawQuery) el.textContent = el.textContent.split(rawQuery).join(original);
        el.style.visibility = 'visible';
      }
    );

    if (rawQuery && document.title.indexOf(rawQuery) !== -1) {
      document.title = document.title.split(rawQuery).join(original);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }
})();